// extracted by mini-css-extract-plugin
export default {"root":"IconEvent_root__ue-g7"};